/* eslint-disable react/prop-types */
import { UploadOutlined } from '@ant-design/icons';
import React, { useEffect, useState, useRef } from 'react';
import {
  Button,
  Input,
  Image,
  Select,
  Upload,
  InputNumber,
  Radio,
  DatePicker,
  Cascader,
  message,
  Space,
  Modal,
} from 'antd';
import { useHistory } from 'umi';
import SubmitForm from '@/components/SubmitForm';
import ProTable from '@ant-design/pro-table';
import { guuid } from '@/utils/utils';
import { getCoachInfo } from '@/services/athena';
import {
  getCoachLobV2,
  saveCoachLobV2,
  listUserOptions,
  getListArea,
  getBankCode,
  getExpertiseConfig,
  editZfbId,
  invalidateSign,
  listZfbChangeLog,
  getCoachProcess,
} from '@/services/coachCalendar';
import { putObject } from '@/utils/upload';
import MyAvatarEditor from '@/components/AvatarEditor';
import AttentionTip from '@/components/attentionTip';
// const { RangePicker } = DatePicker;
import moment from 'moment';
import ImgUpload from '@/components/ImgUpload';
import styles from './index.less';
import OverviewSection from './sections/OverviewSection';
import AlipaySection from './sections/AlipaySection';
import SessionSection from './sections/SessionSection';
import { LazyMount, SectionCard } from '../../../ui';
import { sidOf } from './constants';

const { Option } = Select;

const CoachProfile = ({ tenantId, coachData, header }) => {
  /* ⚠ 教练的“用户ID”在教练列表项里叫 `userId`；`coachUserId` 实测恒为 null
     （tenantId=121 的 9 位教练全部为 null，SIT 实测）。而 getCoachInfo /
     getCoachProcess / ChatListView 要的都是这个用户ID —— 原先四处都读
     `coachData.coachUserId`（undefined），导致「成员信息 / 互动数据」全部为 '--'、
     切成员时也不重新取数。此处收敛成一个变量，避免同类字段再读错。 */
  const coachUserId = coachData?.coachUserId || coachData?.userId;
  const [coachInfo, setCoachInfo] = useState({}); // 新增教练列表状态
  const [processSteps, setProcessSteps] = useState([]);

  const ref = useRef(null);
  const ref1 = useRef(null);
  const ref2 = useRef(null);

  const [, setDetailInfo] = useState({});
  const [adeptClass, setAdeptClass] = useState([]);
  const [coachTags, setCoachTags] = useState([]);
  const [descVideo, setDescVideo] = useState([]);
  const [littaLevel, setLittaLevel] = useState([]);

  // 头像
  const [avatar, setAvatar] = useState(undefined);

  // 半身照
  const [halfBodyPic, setHalfBodyPic] = useState(undefined);

  // 工作类型
  const [workTypeList, setWorkTypeList] = useState([]);
  // 教练类型
  const [coachTypeList, setCoachTypeList] = useState([]);
  // 授课资格
  // const [qualificationsList, setQualificationsList] = useState([]);
  // 工作类型
  const sexTypeList = [
    { type: 1, name: '男' },
    { type: 2, name: '女' },
  ];

  const workYearTypeList = [
    { type: 1, name: '1~3年' },
    { type: 2, name: '4~6年' },
    { type: 3, name: '7~10年' },
    { type: 4, name: '10年以上' },
  ];

  const currentWorkTypeList = [
    { type: 1, name: '工作室老板' },
    { type: 2, name: '健身博主' },
    { type: 3, name: '全职教练' },
    { type: 4, name: '自由教练' },
    { type: 5, name: '健身私教' },
    { type: 6, name: '工作室教练' },
    { type: 7, name: '其他行业从业者' },
  ];

  const [province, setProvince] = useState([]);

  const [bankCode, setBankCode] = useState([]);

  const [, setCoachSettlementMaterialModel] = useState({});
  const [, setCoachBizMaterialModel] = useState({});
  const [, setCoachBaseMaterialModel] = useState({});
  const [idImageFront, setIdImageFront] = useState(undefined);
  const [idImageBack, setIdImageBack] = useState(undefined);
  const [certificateImg, setCertificateImg] = useState([]);
  // 领域信息
  const [expertiseConfigList, setExpertiseConfigList] = useState([]);

  // 支付宝账号修改相关状态
  const [isAlipayModalVisible, setIsAlipayModalVisible] = useState(false);
  const [newAlipayAccount, setNewAlipayAccount] = useState('');
  // 人脸视频预览
  const [faceVideoVisible, setFaceVideoVisible] = useState(false);
  const [faceVideoUrl, setFaceVideoUrl] = useState('');

  const actionRef = useRef();
  const actionRef1 = useRef();
  /* 跟教练绑定的取数：必须随 coachUserId 变化重跑。
     原来这些调用和一个大 effect 混在一起、依赖写成 []，只在挂载时跑一次，
     导致切换教练时「成员信息 / 互动数据」与入驻流程一直是上一位教练的数据。 */
  useEffect(() => {
    initCoachInfo(coachUserId);

    getCoachProcess({
      requestData: {
        coachUserId,
      },
    }).then(({ data, code, msg }) => {
      if (code !== '00000') {
        return;
      }
      setProcessSteps(data.coachProcesses);
    });
  }, [coachUserId, tenantId]);

  /* 应用级字典/枚举（与具体教练无关）：挂载时取一次即可，保持 [] 不随切人重拉 */
  useEffect(() => {
    // 擅长课程
    listUserOptions({ requestData: 'litta.user.adeptClasses' }).then(
      ({ data, code, msg }) => {
        if (code !== '00000') {
          return;
        }
        setAdeptClass(data);
      },
    );
    // 擅长领域
    getExpertiseConfig({ requestData: '' }).then(({ data, code, msg }) => {
      if (code !== '00000') {
        return;
      }
      setExpertiseConfigList(data);
    });
    // 特色标签
    listUserOptions({
      requestData: 'litta.user.coachTags',
    }).then(({ data, code, msg }) => {
      if (code !== '00000') {
        return;
      }
      setCoachTags(data);
    });
    // 等级
    listUserOptions({ requestData: 'litta.user.littaLevels' }).then(
      ({ data, code, msg }) => {
        if (code !== '00000') {
          return;
        }
        setLittaLevel(data);
      },
    );

    // 工作类型
    listUserOptions({ requestData: 'litta.user.workTypes' }).then(
      ({ data, code, msg }) => {
        if (code !== '00000') {
          return;
        }
        setWorkTypeList(data);
      },
    );

    // 教练类型
    listUserOptions({ requestData: 'litta.user.coachTypes' }).then(
      ({ data, code, msg }) => {
        if (code !== '00000') {
          return;
        }
        setCoachTypeList(data);
      },
    );

    getBankCode({ requestData: '' }).then(({ data, code, msg }) => {
      if (code === '00000') {
        setBankCode(data);
      } else {
        message.warn(msg);
      }
    });

    getAreaList();
  }, []);

  useEffect(() => {
    /* 单页平铺后三类表单区块同时可见：把 1/2/3 都灌一次。
       原先只灌当前页签那一类，锚点模式下不预取会导致第 2/3 块表单为空。
       三次调用会各发一次同参 getCoachLobV2 —— 去重需要把「取数」与
       「按 type 灌表单」拆开，本次先保证正确性，拆分留作后续。 */
    ['1', '2', '3'].forEach((type) => getCoachInfos(type));
  }, [coachData.coachId, coachUserId, ref, ref1, ref2]);
  const history = useHistory();
  // 获取教练信息
  const initCoachInfo = (coachUserId) => {
    if (!tenantId) return;
    const requestData = {
      coachUserId: coachUserId,
    };
    getCoachInfo({ requestData: requestData }).then((res) => {
      if (res.code === '00000') {
        setCoachInfo(res.data || {});
      } else {
        message.error(res.msg);
      }
    });
  };

  function getCoachInfos(type) {
    getCoachLobV2({
      requestData: {
        coachId: coachData.coachId,
      },
    }).then(({ msg, data, code }) => {
      // console.log(data);
      if (code !== '00000') {
        return;
      }
      if (!data) {
        return;
      }
      setCoachSettlementMaterialModel(data.coachSettlementMaterialModel);
      setCoachBizMaterialModel(data.coachBizMaterialModel);
      setCoachBaseMaterialModel(data.coachBaseMaterialModel);

      if (type === '1') {
        const coachBaseFormData = {
          realName: data.coachBaseMaterialModel?.realName,
          gender: data.coachBaseMaterialModel?.gender,
          birthday: data.coachBaseMaterialModel?.birthday
            ? moment(data.coachBaseMaterialModel?.birthday)
            : 0,
          region: [
            data.coachBaseMaterialModel?.regionProId,
            data.coachBaseMaterialModel?.regionCityId,
          ],
          occupation: data.coachBaseMaterialModel?.occupation,
          workYearType: data.coachBaseMaterialModel?.workYearType,
          expertiseList: data.coachBaseMaterialModel?.expertiseList || [],
          joinWorkDt: data.coachBaseMaterialModel?.joinWorkDt
            ? moment(data.coachBaseMaterialModel?.joinWorkDt)
            : 0,
        };
        ref.current?.setFieldsValue(coachBaseFormData);
        getAreaList(data.coachBaseMaterialModel.regionProId);
      }

      if (type === '2') {
        setIdImageFront(data.coachSettlementMaterialModel?.idImageFront);
        setIdImageBack(data.coachSettlementMaterialModel?.idImageBack);
        const coachSettlementFormData = {
          idCode: data.coachSettlementMaterialModel?.idCode,
          idImageFront: data.coachSettlementMaterialModel?.idImageFront,
          idImageBack: data.coachSettlementMaterialModel?.idImageBack,
          openBank: data.coachSettlementMaterialModel?.openBank,
          openBankregion: [
            data.coachSettlementMaterialModel?.openBankProId,
            data.coachSettlementMaterialModel?.openBankCityId,
          ],
          alipayAccount: data.coachSettlementMaterialModel?.alipayAccount,
          bankCardCode: data.coachSettlementMaterialModel?.bankCardCode,
          bankCode: data.coachSettlementMaterialModel?.bankCode,
        };

        ref1.current.setFieldsValue(coachSettlementFormData);
        getAreaList(data.coachSettlementMaterialModel?.openBankProId);
      }

      if (type === '3') {
        setDescVideo([
          {
            percent: 1,
            name: '介绍视频.mp4',
            thumbUrl: data.coachBizMaterialModel?.introVideo,
            url: data.coachBizMaterialModel?.introVideo,
          },
        ]);
        setAvatar(data.coachBizMaterialModel?.headImg);
        setHalfBodyPic(data.coachBizMaterialModel?.halfBodyImg);
        setDetailInfo(data);
        const coachBizFormData = {
          realName: data.coachBizMaterialModel?.realName,
          nickName: data.coachBizMaterialModel?.nickName,
          coachTag: data.coachBizMaterialModel?.coachTag.map((item) =>
            String(item),
          ),
          adeptClass: data.coachBizMaterialModel?.adeptClass.map((item) =>
            String(item),
          ),
          headImg: data.coachBizMaterialModel?.headImg,
          workType: String(data.coachBizMaterialModel?.workType),
          coachDesc: data.coachBizMaterialModel?.coachDesc,
          coachType: String(data.coachBizMaterialModel?.coachType),
          hourFee: data.coachBizMaterialModel?.hourFee,
          teachQualifications: data.coachBizMaterialModel?.teachQualifications,
          littaLevel: String(data.coachBizMaterialModel?.littaLevel),
        };
        ref2.current.setFieldsValue(coachBizFormData);
      }
    });
  }

  // 处理支付宝账号修改
  const handleAlipayAccountChange = () => {
    if (!newAlipayAccount) {
      message.warn('请输入新的支付宝账号');
      return;
    }
    editZfbId({
      requestData: {
        coachId: coachData.coachId,
        zfbId: newAlipayAccount,
      },
    }).then(({ data, code, msg }) => {
      if (code !== '00000') {
        message.warn(msg);
        return;
      }
      message.success('修改成功');
      setIsAlipayModalVisible(false);
      setNewAlipayAccount('');
      actionRef.current.reload();
    });
  };

  function getAreaList(id) {
    getListArea({ requestData: 0 }).then(({ data, code, msg }) => {
      if (code === '00000') {
        const arr = data.map((item) => ({
          label: item.name,
          value: item.id,
          isLeaf: false,
        }));
        const index = arr.findIndex((item) => item.value === id);
        if (index < 0) {
          setProvince([...arr]);
          return;
        }
        getListArea({ requestData: id }).then(({ data, code, msg }) => {
          if (code === '00000') {
            arr[index].children = data?.map((item) => ({
              value: item.id,
              label: item.name,
            }));
            setProvince([...arr]);
          } else {
            message.warn(msg);
          }
        });
      } else {
        message.warn(msg);
      }
    });
  }

  const submit = (values, key = '0') => {
    let prams = {};
    const reg = /^([\u4e00-\u9fa5]{0,6})$/gi; // 只允许中文字符

    if (key === '1') {
      if (values.realName.length > 6) {
        message.warn('真实姓名不能大于6个字');
        return;
      }

      if (!reg.test(values.realName)) {
        message.warn('真实姓名只能是汉字');
        return;
      }

      prams = {
        coachBaseMaterialModel: {
          realName: values.realName,
          gender: values.gender,
          birthday: moment(values.birthday).format('YYYY-MM-DD'),
          regionProId: values.region[0],
          regionCityId: values.region[1],
          occupation: values.occupation,
          workYearType: values.workYearType,
          expertiseList: values.expertiseList || [],
          joinWorkDt: moment(values.joinWorkDt).format('YYYY-MM-DD'),
        },
      };
    }
    if (key === '2') {
      prams = {
        coachSettlementMaterialModel: {
          idCode: values.idCode,
          idImageFront,
          idImageBack,
          bankCode: values.bankCode,
          openBank: values.openBank,
          openBankProId: values.openBankregion[0],
          openBankCityId: values.openBankregion[1],
          bankCardCode: values.bankCardCode,
          alipayAccount: values.alipayAccount,
        },
      };
    }
    if (key === '3') {
      if (values.realName.length > 6) {
        message.warn('真实姓名不能大于6个字');
        return;
      }

      if (!reg.test(values.realName)) {
        message.warn('真实姓名只能是汉字');
        return;
      }

      if (!avatar) {
        message.warn('请上传教练头像');
        return;
      }

      prams = {
        coachBizMaterialModel: {
          ...values,
          introVideo: descVideo?.[0]?.url || '',
          headImg: avatar,
          halfBodyImg: halfBodyPic,
        },
      };
    }

    saveCoachLobV2({
      requestData: {
        coachId: coachData.coachId,
        ...prams,
      },
    }).then(({ code, msg }) => {
      // goBack();
      if (code === '00000') {
        message.success(msg);
      } else {
        message.warn(msg);
      }
    });
  };

  const cancel = () => {
    goBack();
  };

  const goBack = () => {
    history.goBack();
    // history.replace({
    //   pathname: '/coachonline',
    //   query: {
    //     name: query.name,
    //     phone: query.phone,
    //     schedule: query.schedule,
    //     workType: query.workType,
    //   },
    // });
  };

  const loadData = (selectedOptions) => {
    const targetOption = selectedOptions[selectedOptions.length - 1];
    // console.log('selectedOptions', selectedOptions);
    targetOption.loading = true;
    getListArea({ requestData: targetOption.value }).then(
      ({ data, code, msg }) => {
        if (code === '00000') {
          targetOption.loading = false;
          targetOption.children = data?.map((item) => ({
            value: item.id,
            label: item.name,
          }));
          setProvince([...province]);
        } else {
          message.warn(msg);
        }
      },
    );
  };

  const formData = [
    {
      name: 'realName',
      label: '教练姓名',
      required: true,
      message: false,
      formItem: <Input placeholder="请输入真实姓名" />,
    },
    {
      name: 'nickName',
      label: '教练花名',
      required: true,
      message: false,
      formItem: <Input placeholder="" />,
    },
    {
      name: 'workType',
      label: '工作类型',
      required: true,
      message: false,
      formItem: (
        <Radio.Group>
          {workTypeList.map((e) => {
            return (
              <Radio value={e.type} key={e.type}>
                {e.name}
              </Radio>
            );
          })}
        </Radio.Group>
      ),
    },
    {
      label: (
        <span>
          <span className={styles.requiredMark}>* </span>
          教练头像
        </span>
      ),
      message: false,
      formItem: (
        <AttentionTip text={'注意：请上传正方形头像'}>
          <MyAvatarEditor defaultImg={avatar} getAvatar={setAvatar} />
        </AttentionTip>
      ),
    },
    {
      label: '教练介绍卡片',
      required: false,
      message: false,
      formItem: (
        <AttentionTip
          text={
            '上传教练介绍卡片，图片大小2M以内，宽高比4:5（建议尺寸600*750），png格式，背景图为透明'
          }
        >
          <Upload
            accept={'image/*'}
            maxCount={1}
            onRemove={() => {
              setHalfBodyPic(undefined);
            }}
            customRequest={({ file, onProgress, onError, onSuccess }) => {
              putObject({
                filename: file.name,
                file,
                onProgress,
                callback: (err, data) => {
                  if (err) {
                    onError(err);
                  }
                  if (data) {
                    setHalfBodyPic(`https://${data.Location}`);
                    onSuccess(data);
                  }
                },
              });
            }}
          >
            {halfBodyPic && (
              <Image preview={false} width={100} src={halfBodyPic} />
            )}
            <div className={styles.mtXxs}>
              <a>上传教练介绍卡片</a>
            </div>
          </Upload>
        </AttentionTip>
      ),
      // formItem: <Image preview={false} width={100} src={detailInfo?.halfBodyImg}/>,
    },
    {
      name: 'coachDesc',
      label: '教练描述',
      required: false,
      message: false,
      formItem: (
        <Input.TextArea
          maxLength={200}
          autoSize={{ minRows: 4, maxRows: 6 }}
          showCount
          placeholder="请输入"
          allowClear
        />
      ),
    },
    {
      // name: 'descVideo',
      label: '介绍视频',
      required: false,
      message: false,
      formItem: (
        <div>
          <Upload
            accept={'video/*'}
            maxCount={1}
            fileList={descVideo}
            onRemove={() => {
              setDescVideo([]);
            }}
            customRequest={({ file, onProgress, onError, onSuccess }) => {
              putObject({
                filename: file.name,
                file,
                onProgress,
                callback: (err, data) => {
                  if (err) {
                    onError(err);
                  }
                  if (data) {
                    const da = {
                      percent: 1,
                      name: file.name,
                      thumbUrl: `https://${data.Location}`,
                      url: `https://${data.Location}`,
                    };
                    setDescVideo([da]);
                    onSuccess(data);
                  }
                },
              });
            }}
          >
            <Button icon={<UploadOutlined />}>点击上传</Button>
          </Upload>
        </div>
      ),
    },
    {
      name: 'littaLevel',
      label: 'litta认证等级',
      required: true,
      message: false,
      formItem: (
        <Select placeholder="请选择" allowClear>
          {littaLevel.map((item) => {
            return (
              <Option value={item.type} key={item.type}>
                {item.name}
              </Option>
            );
          })}
        </Select>
      ),
    },
    {
      name: 'coachTag',
      label: '特色标签',
      required: false,
      message: false,
      formItem: (
        <Select mode="multiple" placeholder="请选择" allowClear>
          {coachTags.map((item) => {
            return (
              <Option value={item.type} key={item.type}>
                {item.name}
              </Option>
            );
          })}
        </Select>
      ),
    },
    {
      name: 'adeptClass',
      label: '擅长课程',
      required: false,
      message: false,
      formItem: (
        <Select mode="multiple" placeholder="请选择" allowClear>
          {adeptClass.map((item) => {
            return (
              <Option value={item.type} key={item.type}>
                {item.name}
              </Option>
            );
          })}
        </Select>
      ),
    },
    {
      // name: 'certificateImg',
      label: '资质证书',
      required: false,
      message: false,
      formItem: (
        <ImgUpload
          // maxSize={5 * 1024 * 1024}
          imgList={certificateImg}
          setImgList={setCertificateImg}
        />
      ),
    },
    {
      name: 'coachType',
      label: '教练类型',
      required: false,
      message: false,
      formItem: (
        <Select placeholder="请选择" allowClear>
          {coachTypeList.map((e) => {
            return (
              <Option value={e.type} key={e.type}>
                {e.name}
              </Option>
            );
          })}
        </Select>
      ),
    },
    {
      name: 'hourFee',
      label: '课时费',
      required: true,
      message: false,
      formItem: (
        <InputNumber
          placeholder="请输入"
          className={styles.w150}
          min={0}
          step={0.01}
          stringMode
        />
      ),
    },
  ];

  const baseFormData = [
    {
      name: 'realName',
      label: '真实姓名',
      required: true,
      message: false,
      formItem: <Input placeholder="请输入真实姓名" />,
    },
    {
      name: 'gender',
      label: '性别',
      required: true,
      message: false,
      formItem: (
        <Radio.Group>
          {sexTypeList.map((e) => {
            return (
              <Radio value={e.type} key={e.type}>
                {e.name}
              </Radio>
            );
          })}
        </Radio.Group>
      ),
    },
    {
      name: 'birthday',
      label: '出生日期',
      required: true,
      message: false,
      formItem: <DatePicker className={styles.wFull} format={'YYYY/MM/DD'} />,
    },
    {
      name: 'region',
      label: '所在城市',
      required: true,
      message: false,
      formItem: (
        <Cascader options={province} loadData={loadData} changeOnSelect />
      ),
    },
    {
      name: 'occupation',
      label: '当前职业',
      required: false,
      message: false,
      formItem: (
        <Select placeholder="请选择" allowClear>
          {currentWorkTypeList.map((e) => {
            return (
              <Option value={e.name} key={e.name}>
                {e.name}
              </Option>
            );
          })}
        </Select>
      ),
    },
    {
      name: 'workYearType',
      label: '从业年限',
      required: false,
      message: false,
      formItem: (
        <Radio.Group>
          {workYearTypeList.map((e) => {
            return (
              <Radio value={e.type} key={e.type}>
                {e.name}
              </Radio>
            );
          })}
        </Radio.Group>
      ),
    },
    {
      name: 'joinWorkDt',
      label: '入行时间',
      required: true,
      message: false,
      formItem: <DatePicker className={styles.wFull} format={'YYYY/MM/DD'} />,
    },
    {
      name: 'expertiseList',
      label: '擅长领域',
      required: false,
      message: false,
      formItem: (
        <Select mode="multiple" placeholder="请选择" allowClear>
          {expertiseConfigList.map((item) => {
            return (
              <Option value={item} key={item}>
                {item}
              </Option>
            );
          })}
        </Select>
      ),
    },
  ];

  const settlementFormData = [
    {
      name: 'idCode',
      label: '身份证号',
      required: true,
      message: false,
      formItem: <Input placeholder="请输入身份证号" />,
    },
    {
      name: 'idImageFront',
      label: '身份证正面照片',
      required: true,
      message: false,
      formItem: (
        <div>
          <AttentionTip text={''}>
            <Upload
              accept={'image/*'}
              maxCount={1}
              customRequest={({ file, onProgress, onError, onSuccess }) => {
                putObject({
                  filename: file.name,
                  file,
                  onProgress,
                  callback: (err, data) => {
                    if (err) {
                      onError(err);
                    }
                    if (data) {
                      setIdImageFront(`https://${data.Location}`);
                      onSuccess(data);
                    }
                  },
                });
              }}
            >
              {idImageFront && (
                <Image
                  preview={false}
                  width={100}
                  src={idImageFront}
                  className={styles.blurred}
                />
              )}
              <div>
                <a>身份证正面照片</a>
              </div>
            </Upload>
          </AttentionTip>
        </div>
      ),
    },
    {
      name: 'idImageBack',
      label: '身份证反面照片',
      required: true,
      message: false,
      formItem: (
        <div>
          <AttentionTip text={''}>
            <Upload
              accept={'image/*'}
              maxCount={1}
              // onRemove={() => {
              //   setPosterPics([]);
              // }}
              customRequest={({ file, onProgress, onError, onSuccess }) => {
                putObject({
                  filename: file.name,
                  file,
                  onProgress,
                  callback: (err, data) => {
                    if (err) {
                      onError(err);
                    }
                    if (data) {
                      setIdImageBack(`https://${data.Location}`);
                      onSuccess(data);
                    }
                  },
                });
              }}
            >
              {idImageBack && (
                <Image
                  preview={false}
                  width={100}
                  src={idImageBack}
                  className={styles.blurred}
                />
              )}
              <div>
                <a>身份证反面照片</a>
              </div>
            </Upload>
          </AttentionTip>
        </div>
      ),
    },
    {
      name: 'bankCode',
      label: '银行',
      required: true,
      message: false,
      formItem: (
        <Select placeholder={'请选择银行'}>
          {bankCode.map((item) => (
            <Option key={item.code} value={item.code}>
              {item.name}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      name: 'openBankregion',
      label: '开户行所在城市',
      required: true,
      message: false,
      formItem: (
        <Cascader options={province} loadData={loadData} changeOnSelect />
      ),
    },
    {
      name: 'openBank',
      label: '开户行',
      required: true,
      message: false,
      formItem: <Input placeholder="请输入开户行" />,
    },
    {
      name: 'bankCardCode',
      label: '银行卡号',
      required: true,
      message: false,
      formItem: <Input placeholder="请输入银行卡号" />,
    },
    {
      name: 'alipayAccount',
      label: '支付宝号',
      required: false,
      message: false,
      formItem: (
        <div className={styles.rowCenter}>
          <Input placeholder="请输入支付宝号" className={styles.mrXs} />
        </div>
      ),
    },
  ];

  // 标记签约失效
  const handleMarkSignInvalid = (record) => {
    Modal.confirm({
      title: '标记失效',
      content: '确定要将该签约记录标记为失效吗？',
      okText: '确定',
      cancelText: '取消',
      onOk: async () => {
        const { code, msg } = await invalidateSign({
          requestData: {
            /* 后端 javadoc：userId 必填。而 SignResponse 并不返回 userId，
               record.userId 恒为 undefined → 值实际来自文件顶部收敛的 coachUserId */
            userId: record.userId ?? coachUserId,
          },
        });
        if (code !== '00000') {
          message.warn(msg || '操作失败');
          return Promise.reject(new Error(msg || '操作失败'));
        }
        message.success('操作成功');
        actionRef.current && actionRef.current.reload();
        // 合同文件列表同步刷新
        actionRef1.current && actionRef1.current.reload();
      },
    });
  };

  return (
    <div>
      {/* 2026-09-17（用户决策）：锚点栏**上提到 MemberTab 的页面级第三栏**
          （与成员列表同级），本组件只渲染 6 个区块；成员头部与「入驻流程」
          并入「概览信息」区块，并去掉原来包住整个详情的 SectionCard 大卡。
          会话记录是无界列表，按 §12.1 的约束排最后；
          三个表单区块**不套 LazyMount**（容器要拿它们的 ref 灌初始值）。 */}
      <section id={sidOf('overview')} className={styles.anchorSection}>
        <LazyMount>
          <OverviewSection
            coachData={coachData}
            coachInfo={coachInfo}
            header={header}
            steps={processSteps}
          />
        </LazyMount>
      </section>

      <section id={sidOf('base')} className={styles.anchorSection}>
        <SectionCard title="基础信息">
          <SubmitForm
            formData={baseFormData}
            submit={(values) => submit(values, '1')}
            onCancel={cancel}
            refs={ref}
            readOnly
          />
        </SectionCard>
      </section>

      <section id={sidOf('settle')} className={styles.anchorSection}>
        <SectionCard title="结算银行">
          <SubmitForm
            formData={settlementFormData}
            submit={(values) => submit(values, '2')}
            onCancel={cancel}
            refs={ref1}
            readOnly
          />
        </SectionCard>
      </section>

      <section id={sidOf('biz')} className={styles.anchorSection}>
        <SectionCard title="业务信息">
          <SubmitForm
            formData={formData}
            submit={(values) => submit(values, '3')}
            onCancel={cancel}
            refs={ref2}
            readOnly
          />
        </SectionCard>
      </section>

      <section id={sidOf('alipay')} className={styles.anchorSection}>
        <LazyMount>
          <AlipaySection
            coachData={coachData}
            coachUserId={coachUserId}
            actionRef={actionRef}
            actionRef1={actionRef1}
            handleMarkSignInvalid={handleMarkSignInvalid}
            setFaceVideoUrl={setFaceVideoUrl}
            setFaceVideoVisible={setFaceVideoVisible}
            setIsAlipayModalVisible={setIsAlipayModalVisible}
            setNewAlipayAccount={setNewAlipayAccount}
          />
        </LazyMount>
      </section>

      <section id={sidOf('session')} className={styles.anchorSection}>
        <LazyMount>
          <SessionSection coachUserId={coachUserId} />
        </LazyMount>
      </section>
      {/* 支付宝账号修改Modal */}
      <Modal
        title="修改支付宝账号"
        destroyOnClose
        visible={isAlipayModalVisible}
        onCancel={() => setIsAlipayModalVisible(false)}
        footer={false}
        width={700}
      >
        <div className={styles.mbL}>
          <div className={styles.rowFlex}>
            <span className={styles.requiredMark}>*</span> 新支付宝账号：
            <Input
              placeholder="请输入新的支付宝账号"
              value={newAlipayAccount}
              onChange={(e) => setNewAlipayAccount(e.target.value)}
              className={styles.flex1}
            />
          </div>
        </div>

        <Space size={100} className={styles.modalActions}>
          <Button
            type="primary"
            onClick={() => {
              handleAlipayAccountChange();
            }}
          >
            确认
          </Button>
          <Button
            type="default"
            onClick={() => {
              setIsAlipayModalVisible(false);
            }}
          >
            取消
          </Button>
        </Space>

        <div>
          <h3>操作记录</h3>
          <ProTable
            columns={[
              {
                title: '操作时间',
                dataIndex: 'operateTime',
                key: 'operateTime',
                valueType: 'dateTime',
              },
              {
                title: '操作人',
                dataIndex: 'operator',
                key: 'operator',
              },
              {
                title: '旧支付宝账号',
                dataIndex: 'oldZhbId',
                key: 'oldZhbId',
              },
              {
                title: '新支付宝账号',
                dataIndex: 'newZhbId',
                key: 'newZhbId',
              },
            ]}
            request={async (params) => {
              const { data, code, msg } = await listZfbChangeLog({
                requestData: {
                  coachId: coachData.coachId,
                  ...params,
                },
                page: {
                  currentPage: params.current || 1,
                  pageSize: params.pageSize || 5,
                },
              });

              if (code !== '00000') {
                message.warn(msg);
                return {
                  data: [],
                  success: false,
                };
              }

              return {
                data: data || [],
                success: true,
                total: data?.length || 0,
              };
            }}
            options={false}
            dateFormatter="string"
            headerTitle={false}
            search={false}
            toolBarRender={false}
            rowKey={guuid}
            pagination={{ pageSize: 5 }}
            size="small"
          />
        </div>
      </Modal>
      {/* 人脸视频查看Modal */}
      <Modal
        title="人脸视频"
        destroyOnClose
        visible={faceVideoVisible}
        footer={null}
        width={480}
        onCancel={() => setFaceVideoVisible(false)}
      >
        <video src={faceVideoUrl} controls autoPlay className={styles.wFull} />
      </Modal>
    </div>
  );
};

export default CoachProfile;
